import { useApp } from "@/context/AppContext";
import { Sun } from "lucide-react";

const SOLAR_NEWS = {
  en: [
    "India crosses 100 GW installed solar capacity — fastest clean-energy scale-up in its history",
    "PM Surya Ghar Muft Bijli Yojana: rooftop solar systems powering over 1 crore households",
    "Madhya Pradesh clears new 750 MW solar park expansion at Rewa–Neemuch corridor",
    "SECI auction records all-time low solar tariff of ₹2.15 per unit for utility-scale projects",
    "India on track for 500 GW non-fossil capacity target by 2030, solar leads the mix",
    "MNRE approves ALMM-II list bringing solar cells under domestic content mandate",
    "Green energy corridor Phase-II links 13 GW of solar parks to the national grid",
    "KUSUM scheme crosses 50 lakh solar agriculture pump installations nationwide",
  ],
  hi: [
    "भारत ने पार की 100 GW सौर ऊर्जा क्षमता — इतिहास की सबसे तेज़ स्वच्छ-ऊर्जा प्रगति",
    "पीएम सूर्य घर मुफ्त बिजली योजना: 1 करोड़ से अधिक घरों में रूफटॉप सोलर सिस्टम",
    "मध्य प्रदेश में रीवा–नीमच कॉरिडोर पर 750 MW नए सोलर पार्क विस्तार को मंज़ूरी",
    "SECI की नीलामी में सोलर टैरिफ ₹2.15 प्रति यूनिट के रिकॉर्ड न्यूनतम स्तर पर",
    "2030 तक 500 GW नॉन-फॉसिल क्षमता लक्ष्य की ओर भारत, सौर ऊर्जा सबसे आगे",
    "MNRE ने जारी की ALMM-II सूची, सोलर सेल भी स्वदेशी निर्माण दायरे में",
    "ग्रीन एनर्जी कॉरिडोर चरण-II से 13 GW सोलर पार्क राष्ट्रीय ग्रिड से जुड़े",
    "कुसुम योजना के तहत देशभर में 50 लाख से अधिक सोलर कृषि पंप स्थापित",
  ],
};

export default function ScadaTicker() {
  const { lang } = useApp();
  const items = SOLAR_NEWS[lang] || SOLAR_NEWS.en;
  const doubled = [...items, ...items];

  return (
    <div className="w-full bg-[#014845] border-y border-teal-400/25 overflow-hidden" data-testid="scada-ticker">
      <div className="flex items-center whitespace-nowrap animate-ticker py-2.5">
        {doubled.map((headline, i) => (
          <span key={`${headline}-${i}`} className="inline-flex items-center gap-2 px-6 text-[12px] font-medium text-white" data-testid={`ticker-news-${i}`}>
            <Sun className="w-3.5 h-3.5 text-amber-300 shrink-0" />
            {headline}
            <span className="w-1.5 h-1.5 rounded-full bg-amber-400 pulse-dot ml-2" />
          </span>
        ))}
      </div>
    </div>
  );
}
